import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="container-page flex flex-col items-center justify-center py-24 text-center md:py-32">
      <span className="font-heading text-7xl font-bold text-primary-200 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这一页好像迷路了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你要找的页面不存在或已被调整。不过别担心，好漫画还在这里等你。
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/rankings"
          className="inline-flex items-center justify-center gap-2 rounded-full border border-background-200 bg-background-100 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300"
        >
          去逛推荐榜单
        </Link>
      </div>
    </section>
  );
}